<template>
  <tk-button
    v-bind="$attrs"
    :disabled="disabled"
    class="tkRightArrowButton"
    v-on="$listeners"
  >
    <slot />
    <tk-right-arrow class="tkRightArrowButton_arrow"/>
  </tk-button>
</template>

<script>
import TkButton from '../../../atoms/TkButton/TkButton'
import TkRightArrow from '../../../atoms/arrow/TkRightArrow/TkRightArrow'

export default {
  name: 'TkRightArrowButton',
  components: {
    TkButton,
    TkRightArrow,
  },
  props: {
    /**
     * Native button disabled attribute
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.tkRightArrowButton {
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid;
  font-size: 100%;
  height: 100%;
  width: 100%;
  text-align: center;

  &.-red {
    background: #F9423A;
    border-color: #f9423a;
    color: #ffffff;
  }

  &.-skelton {
    background: none;
    border-color: #ffffff;
    color: #ffffff;
  }
}

.tkRightArrowButton_arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
</style>
